/**
 * Utility functions for managing traveler map cache
 */

/**
 * Clears all traveler map related cache from browser storage
 * This should be called during logout to prevent data leakage between different user sessions
 */
export const clearTravelerMapCache = (): void => {
  try {
    // Clear map filters from sessionStorage
    sessionStorage.removeItem('mapFilters');
    
    // Clear any other map-related sessionStorage items that might exist
    // (Add more items here if needed in the future)
    
    console.log('Traveler map cache cleared successfully');
  } catch (error) {
    console.error('Error clearing traveler map cache:', error);
  }
};

/**
 * Clears all browser storage related to the application
 * This is a more comprehensive cleanup that can be used during logout
 */
export const clearAllApplicationCache = (): void => {
  try {
    // Clear traveler map specific cache
    clearTravelerMapCache();
    
    // Clear any other application-specific sessionStorage/localStorage items
    // Add more items here as needed
    
    console.log('All application cache cleared successfully');
  } catch (error) {
    console.error('Error clearing application cache:', error);
  }
};